import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import logo from "../../Assets/images/mp-logo.svg"

const Hero = ({handleModal}) => {
    const navigate = useNavigate()
    const [isNavCollapsed, setIsNavCollapsed] = useState(true)

    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed)
    
    const closeNav = () => setIsNavCollapsed(true)

    const handleModalAndCloseNav = (e) => {
        handleModal(e)
        closeNav()
    }

  return (
    <>
      <header>
        <nav className="navbar navbar-header navbar-expand-sm navbar-dark landing-navbar">
          <div className="container">
            <Link className="navbar-brand p-0" to="/">
              <img src={logo} />
            </Link>
            <button 
              className="navbar-toggler" 
              id="toggler" 
              type="button" 
              onClick={handleNavCollapse}
              aria-expanded={!isNavCollapsed}
            >
              <span className="navbar-toggler-icon">
                <div className="bar1"></div>
                <div className="bar2"></div>
                <div className="bar3"></div>
              </span>
            </button>
            <div 
              className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse justify-content-lg-end`} 
              id="mynavbar"
            >
              <ul className="navbar-nav align-items-center">
                <li className="nav-item">
                  <a 
                    className="nav-link default-btn bg-transparent py-2 black-border-btn" 
                    href='#' 
                    onClick={handleModalAndCloseNav}
                  >
                    Sign In / Sign Up
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section className='hdr-banner-sec d-flex align-items-center'>
        <div className='container'>
            <div className="mp-banner-content text-center">
                <h2 className='heading-title'>
                    Land Your First Job Faster 
                    <span className='gr-txt my-2 my-lg-3'>Show Your Skills,</span>
                    Not Just Your Resume
                </h2>
                <p>
                  Create your video portfolio, showcase your skills, and get discovered by top recruiters nationwide
                </p>
                <div className='d-flex flex-column flex-lg-row align-items-center justify-content-center'>
                  <a href='#' className='default-btn blue-bg border-0 mb-2 mb-lg-0 me-lg-3' onClick={handleModalAndCloseNav}>Create Profile </a>
                  <a href='#' className='default-btn border-btn bg-transparent default-border' onClick={handleModalAndCloseNav}>Browse Jobs</a>
                </div>
            </div>
        </div>
      </section>
    </>
  )
}

export default Hero
